import SpacePath from "components/SpacePath";

import { CellComponentProps } from "./types";

type BlueprintIntegrationsListItemSpaceCellProps = CellComponentProps;

const BlueprintIntegrationsListItemSpaceCell = ({
  integration,
}: BlueprintIntegrationsListItemSpaceCellProps) => {
  if (!integration.space) {
    return null;
  }

  return <SpacePath spaceId={integration.space.id} fallbackName={integration.space.name} />;
};

export default BlueprintIntegrationsListItemSpaceCell;
